import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=9 公告
export default function AnnouncementMessage({ msg }) {
  const { attach } = msg;
  console.log(attach);
  return (
    <CustomCardBase
      tagColor="#046e62"
      tagText="公告"
      title={attach?.title}
      gameInfo={attach?.game_info}
      desc={attach?.content}
      descClass="imc-line2"
      onClick={() => {
        general.game = attach?.game_info;
        general.history.push(
          "communityDetail?id=" + attach?.id +
          "&tagid=" + attach?.tagid +
          "&circles_type=" + attach?.circles_type +
          "&topic_id=" + attach?.topic_id
        );
      }}
    />
  );
}
